import React, { Component } from 'react'
import { Menu, Dropdown, Modal, Loader, Responsive } from 'semantic-ui-react'

import Nicklist from '../nicklist/Nicklist'
import Messages from './Messages'
import Config from '../../config/config'
import EventHandler from '../../irc/EventHandler'
import Topic from '../topic/Topic'
import Settings from '../settings/Settings'
import { setCookie, getCookie } from '../../utils/cookies'

require('./chat.scss')

export default class BaseChat extends Component {
  constructor(props) {
    super(props)

    this.state = {
      buffers: [],
      users: [],
      inputText: '',
      topic: '',
      privateChatTarget: null,
      nicklistPopoverShown: false,
      proLayoutEnabled: getCookie('PRO_MODE_ENABLED') === 'true',
      notificationSoundsDisabled: getCookie('NOTIFICATION_SOUNDS_DISABLED') === 'true',
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.promptChangeNickname = this.promptChangeNickname.bind(this)
    this.proLayoutEnabledChanged = this.proLayoutEnabledChanged.bind(this)
    this.notificationSoundsDisabledChanged = this.notificationSoundsDisabledChanged.bind(this)
    this.nicklistUsernameSelected = this.nicklistUsernameSelected.bind(this)
    this.handlePrivateChatClosed = this.handlePrivateChatClosed.bind(this)
    this.toggleNicklist = this.toggleNicklist.bind(this)

    this.send = this.send.bind(this)

    window.onbeforeunload = function(e) {
      return ''
    }

    // Hack so mobile devices fire onClick
    // https://github.com/Semantic-Org/Semantic-UI-React/pull/1833#issuecomment-313713611
    if ('ontouchstart' in document.documentElement) {
      document.body.style.cursor = 'pointer'
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.client && !this.eventHandler) {
      this.eventHandler = new EventHandler(this.props.client)
      this.eventHandler.setAddEvent(this.addEvent.bind(this))
      this.eventHandler.setSetState(this.setState.bind(this))
      this.eventHandler.registerForEvents(this.props.client)
    }

    if (this.props.history !== prevProps.history) {
      let buffers = this.state.buffers
      buffers[Config.channel] = this.props.history
      this.setState({ buffers: buffers })
    }
  }

  render() {
    return (
      <div>
        <Menu className="header-menu">
          <Menu.Item>
            <a href="https://www.the-cabin.com" target="_new">
              <img src="/blackCabinLogo.svg" alt="Cabin Logo" height="30px" />
            </a>
          </Menu.Item>

          <Menu.Menu position="left">
            <Responsive as={Dropdown} item text="#TheCabin" minWidth={300}>
              <Dropdown.Menu>
                <a href="https://www.the-cabin.com/about" target="_new">
                  <Dropdown.Item>About</Dropdown.Item>
                </a>
                <a href="https://www.the-cabin.com/about/history" target="_new">
                  <Dropdown.Item>History</Dropdown.Item>
                </a>
                <a href="https://www.the-cabin.com/help" target="_new">
                  <Dropdown.Item>Help</Dropdown.Item>
                </a>
                <Responsive as={'a'} href="https://www.the-cabin.com/help/technical/" target="_new" maxWidth={660}>
                  <a href="https://itunes.apple.com/us/app/thecabin/id395148231?mt=12" target="_new">
                    <Dropdown.Item>iPhone/iPad App</Dropdown.Item>
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.gabekangas.thecabin" target="_new">
                    <Dropdown.Item>Android App</Dropdown.Item>
                  </a>
                </Responsive>
              </Dropdown.Menu>
            </Responsive>

            <Responsive as={Dropdown} item text="Our Apps" minWidth={660}>
              <Dropdown.Menu>
                <a href="https://itunes.apple.com/us/app/thecabin/id395148231?mt=12" target="_new">
                  <Dropdown.Item>iPhone/iPad</Dropdown.Item>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.gabekangas.thecabin" target="_new">
                  <Dropdown.Item>Android</Dropdown.Item>
                </a>
                <a href="https://www.the-cabin.com/help/technical" target="_new">
                  <Dropdown.Item>Other</Dropdown.Item>
                </a>
              </Dropdown.Menu>
            </Responsive>

            <Menu.Item onClick={this.promptChangeNickname}>Nickname</Menu.Item>
          </Menu.Menu>

          <Menu.Menu position="right">
            <Modal closeOnDimmerClick={true} closeOnDocumentClick={true} dimmer="blurring" closeIcon trigger={<Menu.Item>Settings</Menu.Item>} centered={false}>
              <Settings
                notificationSoundsDisabledChanged={this.notificationSoundsDisabledChanged}
                notificationSoundsDisabled={this.state.notificationSoundsDisabled}
                proLayoutEnabledChanged={this.proLayoutEnabledChanged}
                proLayoutEnabled={this.state.proLayoutEnabled}
              />
            </Modal>

            <Responsive
              as={Menu.Item}
              onClick={this.toggleNicklist}
              maxWidth={660}
              style={{ backgroundColor: this.state.nicklistPopoverShown ? 'lightgray' : 'white' }}
            >
              Users
            </Responsive>
          </Menu.Menu>
        </Menu>

        <div className="column-screen-container">
          <div className="left-row-container">
            <Topic topic={this.props.connecting ? 'Connecting. Please wait...' : this.state.topic} className="topic" />
            <div className="chat-messages-container" onClick={() => this.setState({ nicklistPopoverShown: false })}>
              <Messages
                messageList={this.state.buffers[Config.channel] || []}
                proLayoutEnabled={this.state.proLayoutEnabled}
                client={this.props.client}
                target={Config.channel}
                send={this.send}
                connecting={this.props.connecting}
                loggedIn={this.props.loggedIn}
              />
              <Loader active={this.props.connecting} size="massive" style={{ position: 'fixed' }}>
                <span style={{ lineHeight: 1.2 }}>Please wait while you join #TheCabin...</span>
              </Loader>
            </div>
          </div>

          <Responsive as={React.Fragment} minWidth={660}>
            {this.nicklistView()}
          </Responsive>

          <Responsive as={React.Fragment} maxWidth={660}>
            {this.nicklistPopoverView()}
          </Responsive>

          <Modal
            closeOnDimmerClick={true}
            closeOnDocumentClick={true}
            closeIcon
            style={{ height: '80%' }}
            centered={true}
            size="fullscreen"
            open={this.state.privateChatTarget !== null}
            onClose={this.handlePrivateChatClosed}
          >
            <div className="chat-messages-container">
              <div className="private-messages-header">
                <center>Private chat with {this.state.privateChatTarget}</center>
              </div>
              <Messages
                messageList={this.state.buffers[this.state.privateChatTarget] || []}
                proLayoutEnabled={this.state.proLayoutEnabled}
                target={this.state.privateChatTarget}
                client={this.props.client}
                send={this.send}
              />
            </div>
          </Modal>
        </div>
      </div>
    )
  }

  nicklistView() {
    if (this.state.connecting) {
      return null
    }

    return <Nicklist users={this.state.users} usernameSelected={this.nicklistUsernameSelected} />
  }

  nicklistPopoverView() {
    if (!this.state.nicklistPopoverShown) {
      return null
    }

    return <div className="nicklist-popover">{this.nicklistView()}</div>
  }

  proLayoutEnabledChanged(enabled) {
    setCookie('PRO_MODE_ENABLED', enabled, 1000)
    this.setState({ proLayoutEnabled: enabled })
  }

  notificationSoundsDisabledChanged(enabled) {
    setCookie('NOTIFICATION_SOUNDS_DISABLED', enabled, 1000)
    this.setState({ notificationSoundsDisabled: enabled })
  }

  nicklistUsernameSelected(user) {
    this.setState({ privateChatTarget: user, nicklistPopoverShown: false })
  }

  handlePrivateChatClosed() {
    this.setState({ privateChatTarget: null })
  }

  changeNickname(newNickname) {
    this.props.client.changeNickname(newNickname)
    setCookie('NICKNAME', newNickname)
  }

  promptChangeNickname(event) {
    const newNickname = prompt('What would you like to change your nickname to?', this.props.client.nick)
    if (newNickname && newNickname !== this.props.client.nick) {
      this.changeNickname(newNickname)
    }
  }

  handleInputChange(event) {
    this.setState({ inputText: event.target.value })
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.send(this.state.inputText, Config.channel)
    }
  }

  send(text, target) {
    if (text.length >= 3 && text.substring(0, 3) === '/me') {
      const sanitizedString = text.substring(3)
      this.props.client.sendAction(target, sanitizedString)
    } else if (text.substring(0, 5) === '/nick') {
      const newNickname = text.substring(5)
      this.changeNickname(newNickname)
    } else {
      this.props.client.sendMessage(target, text)
    }
    setTimeout(
      function() {
        this.setState({ inputText: '' })
      }.bind(this),
    )
  }

  addEvent(event) {
    let isPrivateMessage = false
    let buffers = this.state.buffers
    let bufferName

    if (event.target === this.props.client.nickname) {
      bufferName = event.nick
      isPrivateMessage = true
    } else {
      bufferName = event.target
    }

    let buffer = buffers[bufferName]

    if (!buffer) {
      buffer = []
    }

    buffer.push(event)
    buffers[bufferName] = buffer

    if (isPrivateMessage) {
      this.setState({ buffers: buffers, privateChatTarget: event.nick })
    } else {
      this.setState({ buffers: buffers })
    }
  }

  toggleNicklist() {
    const show = !this.state.nicklistPopoverShown
    this.setState({ nicklistPopoverShown: show })
  }
}



// WEBPACK FOOTER //
// ./src/views/chat/BaseChat.jsx